import moment from 'moment'
import 'moment/locale/es'

moment.locale('es')

export function iso(date) {
  return moment(date).format('YYYY-MM-DD')
}

export function buildMonth(cursor) {
  const start = moment(cursor).startOf('month')
  const gridStart = start.clone().startOf('isoWeek')
  const days = []
  for (let i = 0; i < 42; i += 1) {
    const day = gridStart.clone().add(i, 'days')
    days.push({
      iso: day.format('YYYY-MM-DD'),
      label: day.date(),
      inMonth: day.month() === start.month(),
    })
  }
  return {
    title: start.format('MMMM YYYY'),
    weekdays: ['L', 'M', 'X', 'J', 'V', 'S', 'D'],
    days,
  }
}

export function inRange(day, inicio, fin) {
  if (!inicio || !fin) return false
  const [from, to] = inicio <= fin ? [inicio, fin] : [fin, inicio]
  return day >= from && day <= to
}

/*
 * Rangos rápidos para filtros de fecha. Cada pantalla elige su juego:
 * - RANGOS_RAPIDOS (fecha de alta, etc.): todos terminan hoy.
 * - RANGOS_VISITA (última visita): quién vino hace poco y quién no ha vuelto.
 *   "Hace más de…" es un rango abierto (sin inicio) y es el complemento
 *   exacto de "Últimos…": no se traslapan ni dejan huecos.
 */
export const RANGOS_RAPIDOS = [
  { clave: 'este-mes', label: 'Este mes' },
  { clave: 'este-anio', label: 'Este año' },
  { clave: 'ultimo-anio', label: 'Último año' },
  { clave: 'ultimos-2-anios', label: 'Últimos 2 años' },
]

export const RANGOS_VISITA = [
  { clave: 'ultimos-30-dias', label: 'Últimos 30 días', grupo: 'Vinieron' },
  { clave: 'ultimos-3-meses', label: 'Últimos 3 meses', grupo: 'Vinieron' },
  { clave: 'ultimos-6-meses', label: 'Últimos 6 meses', grupo: 'Vinieron' },
  { clave: 'mas-de-6-meses', label: 'Hace más de 6 meses', grupo: 'No han vuelto' },
  { clave: 'mas-de-1-anio', label: 'Hace más de 1 año', grupo: 'No han vuelto' },
]

// Proveedores (última compra): mismos rangos que la última visita
export const RANGOS_COMPRA = RANGOS_VISITA.map((rango) => ({
  ...rango,
  grupo: rango.grupo === 'Vinieron' ? 'Les compramos' : 'Sin comprarles',
}))

const DESDE_HACE = {
  'ultimo-anio': [1, 'year'],
  'ultimos-2-anios': [2, 'years'],
  'ultimos-30-dias': [30, 'days'],
  'ultimos-3-meses': [3, 'months'],
  'ultimos-6-meses': [6, 'months'],
}

const ANTES_DE_HACE = {
  'mas-de-6-meses': [6, 'months'],
  'mas-de-1-anio': [1, 'year'],
}

/* { inicio, fin } en YYYY-MM-DD; inicio '' = sin límite inferior. */
export function rangoRapido(clave, hoy = new Date()) {
  const fin = moment(hoy).startOf('day')
  const formato = (m) => m.format('YYYY-MM-DD')
  if (clave === 'este-mes') return { inicio: formato(fin.clone().startOf('month')), fin: formato(fin) }
  if (clave === 'este-anio') return { inicio: formato(fin.clone().startOf('year')), fin: formato(fin) }
  if (DESDE_HACE[clave]) return { inicio: formato(fin.clone().subtract(...DESDE_HACE[clave])), fin: formato(fin) }
  if (ANTES_DE_HACE[clave]) {
    // El día anterior al inicio de "Últimos…": complemento exacto
    return { inicio: '', fin: formato(fin.clone().subtract(...ANTES_DE_HACE[clave]).subtract(1, 'day')) }
  }
  return null
}

/* Qué rango rápido de `opciones` corresponde a inicio/fin (null si es personalizado). */
export function rangoRapidoActivo(inicio, fin, hoy = new Date(), opciones = RANGOS_RAPIDOS) {
  if (!inicio && !fin) return null
  const opcion = opciones.find((o) => {
    const rango = rangoRapido(o.clave, hoy)
    return rango && rango.inicio === (inicio || '') && rango.fin === (fin || '')
  })
  return opcion ? opcion.clave : null
}

/* Etiqueta del rango en DD/MM/AAAA: "01/09/2026 – 30/09/2026", "Hasta 29/03/2026". */
export function etiquetaRango(inicio, fin) {
  const desde = moment(inicio, 'YYYY-MM-DD', true)
  const hasta = moment(fin, 'YYYY-MM-DD', true)
  if (!desde.isValid() && hasta.isValid()) return `Hasta ${hasta.format('DD/MM/YYYY')}`
  if (desde.isValid() && !hasta.isValid()) return `Desde ${desde.format('DD/MM/YYYY')}`
  if (!desde.isValid() || !hasta.isValid()) return ''
  if (desde.isSame(hasta, 'day')) return desde.format('DD/MM/YYYY')
  return `${desde.format('DD/MM/YYYY')} – ${hasta.format('DD/MM/YYYY')}`
}
